module.exports = __webpack_public_path__ + "static/media/Jose_Graziano_mobile.73191548.jpg";